import request from "@/utils/request";

export  function save(data){
  return request({
    method: "post",
    url: '/system/componentGroup/save',
    data,
  });
}
export  function del(data){
  return request({
    method: "post",
    url: '/system/componentGroup/delete',
    data,
  });
}
export  function list(data){
  return request({
    method: "post",
    url: '/system/componentGroup/getList',
    data,
  });
}
export  function detail(data){
  return request({
    method: "get",
    url: '/system/componentGroup/detail',
    params:data,
  });
}


